import { GameFreeSpinsCounterProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameFreeSpinsCounterProperties";
export class FreeSpinsCounterLandscapeProperties extends GameFreeSpinsCounterProperties {
}
